import { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import * as API from "../services/API";

export default function EventLinkModal({ initialName, onClose, onInsert }) {
  const [name, setName] = useState(initialName || "");
  const [url, setUrl] = useState("");
  const [useDocument, setUseDocument] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [documentId, setDocumentId] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    API.getDocumentLink((res) => {
      if (!active) return;
      setDocuments([...(res.data.data || [])].sort((a, b) => a.name.localeCompare(b.name, "fr")));
      setLoading(false);
    }, () => {
      if (!active) return;
      setLoadError("Impossible de charger les documents. Fermez puis rouvrez cette fenêtre pour réessayer.");
      setLoading(false);
    });
    return () => { active = false; };
  }, []);

  const submit = (event) => {
    event.preventDefault();
    if (!name.trim()) return setError("Le nom du lien est obligatoire.");
    const selected = documents.find((doc) => doc.fileId === documentId);
    if (useDocument && !selected) return setError("Sélectionnez un document.");
    const href = useDocument
      ? `/api/file/getbyid/${encodeURIComponent(selected.fileId)}` : url.trim();
    try {
      const parsed = new URL(href, window.location.origin);
      if (!href || !["https:", "http:"].includes(parsed.protocol) ||
          (!useDocument && !/^https?:\/\//i.test(href) && !/^\/(?!\/)/.test(href))) throw new Error();
    } catch {
      return setError("Saisissez une adresse http:// ou https:// valide, ou un chemin commençant par /.");
    }
    const link = document.createElement("a");
    link.setAttribute("href", href);
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.textContent = name.trim();
    onInsert(link.outerHTML);
  };

  return <Modal show onHide={onClose} centered backdrop="static" aria-labelledby="event-link-title">
    <Form onSubmit={submit}>
      <Modal.Header closeButton><Modal.Title id="event-link-title">Insérer un lien</Modal.Title></Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3" controlId="event-link-name">
          <Form.Label>Nom du lien</Form.Label>
          <Form.Control autoFocus value={name} onChange={(e) => setName(e.target.value)} />
        </Form.Group>
        <Form.Check className="mb-3" id="event-link-document" label="Utiliser un lien documentaire déjà enregistré"
          checked={useDocument} onChange={(e) => { setUseDocument(e.target.checked); setError(""); }} />
        {useDocument ? <Form.Group controlId="event-link-select">
          <Form.Label>Document</Form.Label>
          <Form.Select value={documentId} disabled={loading || !!loadError || !documents.length}
            onChange={(e) => {
              setDocumentId(e.target.value);
              const selected = documents.find((doc) => doc.fileId === e.target.value);
              if (selected) setName(selected.name);
            }}>
            <option value="">Sélectionner un document par son nom</option>
            {documents.map((doc) => <option key={doc.fileId} value={doc.fileId}>{doc.name}</option>)}
          </Form.Select>
          {loading && <p role="status">Chargement des documents…</p>}
          {loadError && <p role="alert" className="text-danger">{loadError}</p>}
          {!loading && !loadError && !documents.length && <p>Aucun lien documentaire enregistré.</p>}
        </Form.Group> : <Form.Group controlId="event-link-url">
          <Form.Label>Lien</Form.Label>
          <Form.Control value={url} placeholder="https://…" onChange={(e) => setUrl(e.target.value)} />
        </Form.Group>}
        {error && <p role="alert" className="text-danger mt-3">{error}</p>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Annuler</Button>
        <Button type="submit" disabled={useDocument && (loading || !!loadError || !documentId)}>Insérer</Button>
      </Modal.Footer>
    </Form>
  </Modal>;
}
